import { render } from "./Evaluation6.vue?vue&type=template&id=4d1da628"
import script from "./Evaluation6.vue?vue&type=script&lang=js"
export * from "./Evaluation6.vue?vue&type=script&lang=js"
script.render = render

export default script